import { analyticsTrackEvent } from '~/core/analytics';

export const PWA_ADD_TO_HOME_SCREEN = 'PWA - Add to home screen';
export const MAPP_LOADED_IN_IFRAME = 'Mapp - Loaded in iframe';

export const trackIfSiteLoadedWithinIframe = () => {
  try {
    if (window.self !== window.top) {
      let parentProperties;
      try {
        parentProperties = {
          parentHref: window.parent.location.href,
          parentHost: window.parent.location.host,
          parentPath: window.parent.location.pathname,
        };
      } catch {
        parentProperties = {};
      }
      analyticsTrackEvent(MAPP_LOADED_IN_IFRAME, {
        ...parentProperties,
        currentLocation: window.location.href,
        parentLocation: window.location.ancestorOrigins?.[0] || 'Unavailable',
        userAgent: navigator.userAgent,
        documentReferrer: document.referrer,
      });
    }
  } catch {
    return;
  }
};
